export default __webpack_public_path__ + "static/media/IMG-20241005-WA0033.8b1ad561.jpg";